import { Component, computed, inject, Input, OnInit, Signal, signal } from '@angular/core';
import { MarketplaceFacade, MarketplaceItemV2, MarketplaceV2Query } from '@fgb/core';
import { Subject } from 'rxjs';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
@Component({
  selector: 'fgb-marketplace-detail-page',
  templateUrl: './marketplace-detail-page.component.html',
  styleUrls: ['./marketplace-detail-page.component.scss'],
})
export class MarketplaceDetailPageComponent implements OnInit {
  screenType = ScreenType;
  destroyed$: Subject<void> = new Subject<void>();
  @Input() id: number;
  private readonly marketplaceFacade = inject(MarketplaceFacade);
  private readonly marketplaceQuery = inject(MarketplaceV2Query);
  public readonly location = inject(Location);
  private readonly router = inject(Router);

  private marketplace: Signal<MarketplaceItemV2 | null> = signal(null);
  marketplaceItemType = computed(() => this.marketplaceQuery.resolveItemTypeContext(this.marketplace()!));

  constructor() {}

  ngOnInit() {
    this.marketplaceFacade.fetchMarketplaceItemById(this.id);
    this.marketplace = this.marketplaceQuery.getMarketplaceById();
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  goBack() {
    this.router.navigateByUrl(this.marketplaceItemType().backLink);
  }
}
